import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "antd";
import { Pagination } from "@mui/material";
import { allWalletByWabaQuery, getTenantWaba } from "../../store/actions/tenantAction";
import { getTenants } from "../../store/actions/partnerAction";
import moment from "moment-timezone";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import TypeableSelect from "../../components/Dropdowns/TypeableSelect";
import { useTranslation } from "react-i18next";
const { RangePicker } = DatePicker;

function WabaCreditReport({ showSidebar }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [walletData, setWalletData] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [wabas, setWabas] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [filter, setFilter] = useState({ criteria: {} });
    const [dateFilter, setDateFilter] = useState(() => {
        const start = dayjs().subtract(1, "month");
        const end = dayjs();
        return {
            property: "createdAt",
            operator: "RANGE",
            lowerBound: Date.parse(start.toDate()),
            upperBound: Date.parse(end.add(1, "hour").toDate()),
        };
    });
    const partnerReducer = useSelector((state) => state.partnerReducer);
    const itemParPage = parseInt(process.env.REACT_APP_ITEMS_PER_PAGE);
    const partnerTimezone =
        partnerReducer.partnerDetails?.timezone ??
        Intl.DateTimeFormat().resolvedOptions().timeZone;

    useEffect(() => {
        dispatch(
            getTenants(
                {
                    select: ["distinct t.id,t.name"],
                    criteria: { active: true },
                    count: true,
                    size: 500,
                    offset: 0,
                },
                (d) => {
                    setCompanyList(d?.data ?? []);
                    if (d?.data?.length > 0) {
                        // setFilter((prev) => ({
                        //     ...prev,
                        //     criteria: { ...prev.criteria, tenantId: d.data[0].id },
                        // }));
                    }
                }
            )
        );
    }, []);

    useEffect(() => {
        if (filter?.criteria?.tenantId) {
            dispatch(
                getTenantWaba(
                    { tenantId: filter.criteria.tenantId, criteria: { active: true } },
                    (d) => {
                        setWabas(d?.data ?? []);
                        if (d?.data?.length > 0) {
                            setFilter((prev) => ({
                                ...prev,
                                criteria: { ...prev.criteria, tenantWabaId: parseInt(d.data[0].id) },
                            }));
                        }
                    }
                )
            );
        }
    }, [filter?.criteria?.tenantId]);

    const onSearch = () => {
        //const fl = dateFilter ? [dateFilter] : [];
        const criteria = {};
        if (filter?.criteria?.tenantWabaId) criteria.tenantWabaId = filter.criteria.tenantWabaId;
        if (filter?.criteria?.tenantId) criteria.tenantId = filter?.criteria?.tenantId;
        dispatch(
            allWalletByWabaQuery(
                {
                    criteria: criteria,
                    //filter: fl,
                    count: true,
                    size: itemParPage,
                    offset: (currentPage - 1) * itemParPage
                },
                (d) => {
                    setWalletData(d?.data ?? []);
                    setTotalPages(Math.ceil((d?.count ?? 0) / itemParPage));
                }
            )
        );
    };

    useEffect(() => {
        onSearch();
    }, [currentPage, filter?.criteria?.tenantWabaId]);


    const handleSearch = () => {
        if (currentPage === 1) {
            onSearch();
        } else {
            setCurrentPage(1);
        }
    };

    const exportReport = () => {
        //const fl = dateFilter ? [dateFilter] : [];
        const criteria = {};
        if (filter?.criteria?.tenantWabaId) criteria.tenantWabaId = filter.criteria.tenantWabaId;
        if (filter?.criteria?.tenantId) criteria.tenantId = filter?.criteria?.tenantId;
        dispatch(
            allWalletByWabaQuery(
                {
                    criteria: criteria,
                    //filter: fl,
                    count: true,
                    size: 1000000,
                    offset: 0
                },
                (d) => {
                    const data = (d?.data ?? []).map((item, i) => ({
                        "Sr. No.": i + 1,
                        "Company Name": item.tenantName ?? "-",
                        "Waba": item.wabaName
                            ? `${item.wabaName}${item.phone ? ` +${item.phoneCode} ${item.phone}` : ""}`
                            : "-",
                        "Balance Amount": item.accountType === "POSTPAID" ?
                            "Used :" + " " + item.currencyCode + " " + (item.balanceAmount ? parseFloat(Math.abs(item.balanceAmount ?? 0)).toFixed(3) : 0)
                            : "Remaining :" + " " + item.currencyCode + " " + (item.balanceAmount ? parseFloat(item.balanceAmount ?? 0).toFixed(3) : 0)
                    }));
                    const workbook = XLSX.utils.book_new();
                    const worksheet = XLSX.utils.json_to_sheet(data);
                    XLSX.utils.book_append_sheet(workbook, worksheet, "waba_credit_report");
                    XLSX.writeFile(workbook, "waba_credit_report.xlsx");
                }
            )
        );
    };

    return (
        <div className="h-screen">
            <div
                className={`fixed top-[30px] ${showSidebar ? "fullWidth" : "fullWidth1"
                    } transition-all duration-200 ease-out z-30 bg-white mb-[0px]`}
            >
                <div className="flex gap-5 justify-between px-5 py-[8.5px] min-h-[53.8px] text-base text-center bg-white border-b-[1px] border-[#e9ebf0] border-solid max-md:flex-wrap">
                    <div className="flex gap-2 items-center my-auto font-medium text-black whitespace-nowrap cursor-pointer">
                        <i className="fa-solid fa-wallet text-[14px] text-theme"></i>
                        <div className="text-[14px] font-medium">{t("WABA Balance Report")}</div>
                    </div>
                    <div className="flex gap-2 items-center">
                        <button
                            type="button"
                            onClick={exportReport}
                            className="min-w-[76px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary"
                        >
                            {t("Download Excel")}
                        </button>
                    </div>
                </div>
                <div className="bg-white text-black font-medium px-5 pt-[6px] pb-[10px] box-border border-b">
                    <div className="grid grid-cols-12 gap-4 items-end">
                        <div className="flex flex-col col-span-3">
                            <div className="text-[#656F7D] text-[13px] font-normal mb-1">
                                <label>{t("Company")}</label>
                            </div>
                            <TypeableSelect
                                list={companyList}
                                selected={filter.criteria}
                                labelField="name"
                                valueField="id"
                                placeholder={t("Company Name")}
                                onSelect={(s) => {
                                    if (s?.id) {
                                        setWabas([]);
                                        setFilter({ criteria: { tenantId: s.id } });
                                    } else {
                                        setWabas([]);
                                        setFilter({ criteria: {} });
                                    }
                                }}
                            />
                        </div>
                        <div className="flex flex-col col-span-2">
                            <div className="text-[#656F7D] text-[13px] font-normal mb-1">
                                <label>{t("WABA")}</label>
                            </div>
                            <select
                                className="border border-gray-300 rounded py-[8px] px-[12px] focus:outline-none focus:ring-[0.5px] focus:ring-theme text-[14px] text-black"
                                onChange={(e) => {
                                    setFilter((prev) => ({
                                        ...prev,
                                        criteria: { ...prev.criteria, tenantWabaId: parseInt(e.target.value) },
                                    }));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="">{t("All WABAs")}</option>
                                {wabas.map((w, i) => (
                                    <option value={w.id} key={i}>
                                        {`${w?.teamName ?? ""}  +${w?.phoneCode} ${w?.phone}`}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="flex flex-col">
                            <button
                                type="button"
                                className="justify-center items-center flex px-2 h-10 py-1 font-semibold text-[14px] text-white bg-theme rounded cursor-pointer"
                                onClick={handleSearch}
                            >
                                {t("Search")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col h-full justify-between grow">
                <div className="px-5 pt-5 mt-[9rem] mb-[20px]">
                    {walletData && walletData.length > 0 ? (
                        <table className="text-sm text-left mt-1 rtl:text-right text-midBlack w-full overflow-x-auto">
                            <thead className="text-[14px] text-midBlack bg-gray-200">
                                <tr>
                                    <th scope="col" className="pb-1 font-[500] pr-2 pl-2">
                                        {t("Sr. No.")}
                                    </th>
                                    <th scope="col" className="font-[500] py-3 pl-1 pr-2">
                                        {t("Company Name")}
                                    </th>
                                    <th scope="col" className="font-[500] min-w-[160px]">
                                        {t("WABA")}
                                    </th>
                                    {/* <th scope="col" className="font-[500]">
                                        {t("Transaction Amount")}
                                    </th> */}
                                    <th scope="col" className="font-[500]">
                                        {t("Transaction Type")}
                                    </th>
                                    <th scope="col" className="font-[500] px-4">
                                        {t("Balance Amount")}
                                    </th>
                                    {/* <th scope="col" className="font-[500]">
                                        {t("Amount Source")}
                                    </th>
                                    <th scope="col" className="font-[500]">
                                        {t("Date & Time")}
                                    </th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {walletData.map((item, i) => (
                                    <tr className="bg-white border-b" key={item.id ?? i}>
                                        <td className="py-3 text-[13px] pl-2">
                                            {currentPage === 1
                                                ? i + 1
                                                : itemParPage * (currentPage - 1) + (i + 1)}
                                        </td>
                                        <td className="py-3 text-[13px] pl-1 pr-2 font-normal">
                                            {item.tenantName ?? item.tenantId ?? "-"}
                                        </td>
                                        <td className="py-3 text-[13px] font-normal">
                                            {item.wabaName
                                                ? `${item.wabaName}${item.phone ? ` +${item.phoneCode} ${item.phone}` : ""}`
                                                : "-"}
                                        </td>
                                        {/* <td className="py-3 text-[13px] font-normal">
                                            <span
                                                className={
                                                    item.walletTransactionType === "DEBIT"
                                                        ? "text-red-500"
                                                        : "text-green-600"
                                                }
                                            >
                                                {item.walletTransactionType === "DEBIT" ? "-" : "+"}
                                                {item.transactionAmount}
                                            </span>
                                        </td> */}
                                        <td className="py-3 text-[13px] font-normal">
                                            <span
                                                className={`px-2 py-[2px] rounded text-[12px] font-medium ${item.walletTransactionType === "DEBIT"
                                                    ? "bg-red-100 text-red-600"
                                                    : "bg-green-100 text-green-700"
                                                    }`}
                                            >
                                                {item.walletTransactionType ?? "-"}
                                            </span>
                                        </td>
                                        <td className="py-3 text-[13px] font-normal px-6">
                                            {item.accountType === "POSTPAID" ?
                                                <div> {t("Used")} : {item.currencyCode}{" "} {item.balanceAmount ? parseFloat(Math.abs(item.balanceAmount ?? 0)).toFixed(3) : 0}</div>
                                                : <div> {t("Remaining")} : {item.currencyCode}{" "} {item.balanceAmount ? parseFloat(item.balanceAmount ?? 0).toFixed(3) : 0}</div>
                                            }
                                        </td>
                                        {/* <td className="py-3 text-[13px] font-normal">
                                            {item.amountSource ?? "-"}
                                        </td>
                                        <td className="py-3 text-[13px] font-normal">
                                            {item.createdAt
                                                ? moment
                                                    .utc(item.createdAt)
                                                    .tz(partnerTimezone)
                                                    .format("YYYY-MM-DD hh:mm A")
                                                : "-"}
                                        </td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="flex justify-center items-center h-[300px] text-gray-400 text-[14px]">
                            {t("No records found")}
                        </div>
                    )}
                </div>

                <div className="px-5 flex gap-2 sticky bottom-0 justify-end w-full bg-white py-[10px] border-t-[1px] border-[#eeeeee] z-[10]">
                    {totalPages > 1 && (
                        <div className="flex overflow-x-auto sm:justify-center bottom-0 my-2">
                            <Pagination
                                page={currentPage}
                                count={totalPages}
                                onChange={(event, page) => setCurrentPage(page)}
                                shape="rounded"
                                color="secondary"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default WabaCreditReport;
